import React from 'react';
import PropTypes from 'prop-types';
import CustomDialog from '@/components/common/CustomDialog';
import useDonation from '@/lib/hooks/swr/useContribution';
import translate from '@/lib/intl/translate';

function DeleteContributionModal({ donationId, onClose, onSuccess, open }) {
  const { remove } = useDonation(donationId);
  const [isDeleting, setIsDeleting] = React.useState(false);
  const handleActionButton = async () => {
    setIsDeleting(true);
    await remove();
    onSuccess();
  };

  return (
    <CustomDialog
      actionButtonLabel={translate('DELETE')}
      dialogHeader={translate('CONTRIBUTION_DELETE_CONTRIBUTION')}
      disableActionButton={isDeleting}
      handleActionButton={handleActionButton}
      onClose={onClose}
      open={open}
      fullWidth
    >
      <div className="type-body1">
        {translate('CONTRIBUTE_DELETE_CONFIRMATION')}
      </div>
    </CustomDialog>
  );
}

DeleteContributionModal.propTypes = {
  donationId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
};

DeleteContributionModal.defaultProps = {
  onClose: () => {},
  onSuccess: () => {},
  open: false,
};

export default DeleteContributionModal;
